import { Component, ElementRef, EventEmitter, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { ConfirmDialogComponent } from '@app/pages/common/confirm-dialog/confirm-dialog.component';
import { TranscriptService } from '@app/_core/services/transcript-service.service';
@Component({
  selector: 'app-ai-note-template',
  templateUrl: './ai-note-template.component.html',
  styleUrls: ['./ai-note-template.component.scss']
})
export class AiNoteTemplateComponent implements OnInit, OnDestroy {
  activeTab: 'transcript' | 'sentiment' | 'overview' = 'transcript';
  copied = false;
  public onClose: Subject<string>;
  
  // Received from parent component
  Subject: string = '';
  Category: string = '';
  Issue: string = '';
  caseNoteData: any = {};
  private confirmModalRef!: BsModalRef;
  transcriptData: any = { Sentences: [] };
  transcriptMessage : any;
  getTranscriptFn?: () => any;
  SummaryHeader: { [key: string]: string } =
  {
      'CallSummary': 'Conversation Summary:',
      'IssueResolved': 'Issue Resolved:',
      'AgentBehavior': 'Agent Behavior:',
      'InCompleteCall': 'InComplete Call:',
      'CustomerSatisfaction': 'Customer Satisfaction:',
      'CallerPurpose': 'Caller Purpose:',
      'IssueIdentified': 'Issue Identified:',
      'ActionTaken': 'Action Taken:',
  };
  copyNoteTimeout: any;
  closeModalTimeout: any;
  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private transcriptService: TranscriptService,
  ) { }

  @ViewChild('overviewTextarea') overviewTextarea!: ElementRef;
  
  ngOnInit() {
    this.onClose = new Subject();
    this.transcriptService
    .getTranscriptSnapshot()
    .pipe(
      // make sure you have: import { filter, take } from 'rxjs/operators';
      filter((d: any | null): d is any => d != null),
      take(1)
    )
    .subscribe((data) => {
      // map + (optional) sort so your HTML can use sentence.formattedTime
      const sentences = (data?.Sentences ?? [])
        .map((s: any) => ({
          ...s,
          formattedTime: s?.TimeStamp
            ? new Date(s.TimeStamp).toLocaleString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true
              })
            : ''
        }))
        .sort((a: any, b: any) => (a?.SentenceIndex ?? 0) - (b?.SentenceIndex ?? 0));
 
      this.transcriptData = { ...(data || {}), Sentences: sentences };
      // Call summary
      console.log('transcriptData (snapshot)', this.transcriptData);
    });
  }

  trackByIndex(index: number) {
    return index;
  }
 
  copyNotes(event: MouseEvent) {
    event.stopPropagation();
    
    const initialState = {
      contentMsg: 'This will overwrite the existing notes, do you want to proceed?',
      cancelBtnValue: 'No',
      confirmBtnValue: 'Yes',
      isConfirm: true,
      isDelete: false,
    };

    const config: ModalOptions = {
      class: 'confirm-dialog modal-wd-290',
      initialState,
    };

    this.confirmModalRef = this.modalService.show(ConfirmDialogComponent, config);
    this.confirmModalRef.content.event.subscribe((result: any) => {
      if (result.value == 'confirm') {
        this.confirmModalRef.hide();
        
        // Execute the copy logic
        if (this.overviewTextarea && this.overviewTextarea.nativeElement) {
          const text = this.overviewTextarea.nativeElement.value;
          
          // Copy to clipboard
          navigator.clipboard.writeText(text).then(() => {
            this.copied = true;
            this.copyNoteTimeout = setTimeout(() => (this.copied = false), 2000);
          });
          
          // Pass the text back to the parent component
          this.onClose.next(text);
          
          // Close the modal after a short delay to show the "Copied" message
          this.closeModalTimeout = setTimeout(() => {
            this.bsModalRef.hide();
          }, 500);
        }
      } else if (result.value == 'cancel') {
        // Do nothing, just close the confirmation dialog
        this.confirmModalRef.hide();
      }
    });
  }

  close() {
    const initialState = {
      contentMsg: 'If you continue you will lose any changes you have made.',
      cancelBtnValue: 'No',
      confirmBtnValue: 'Yes',
      isConfirm: true,
      isDelete: false,
    };

    const config: ModalOptions = {
      class: 'confirm-dialog modal-wd-290',
      initialState,
    };

    this.confirmModalRef = this.modalService.show(ConfirmDialogComponent, config);
    this.confirmModalRef.content.event.subscribe((result: any) => {
      if (result.value == 'confirm') {
        this.confirmModalRef.hide();
        this.bsModalRef.hide();
      } else if (result.value == 'cancel') {
        this.confirmModalRef.hide();
      }
    });
  }
  ngOnDestroy() {
    this.copyNoteTimeout && clearTimeout(this.copyNoteTimeout);
    this.closeModalTimeout && clearTimeout(this.closeModalTimeout);
  } 
}

